module.exports = __webpack_public_path__ + "static/media/rightHand.ce8018cb.svg";